import React from 'react'
import PropTypes from 'prop-types'

import app from 'common/builder/components/chart/FlowChart/app'
import CachedView from 'common/builder/components/chart/FlowChart/nodes/shared/CachedView'

export default class ConnectorPoint extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    isTarget: PropTypes.bool,
    style: PropTypes.object,
  }

  static defaultProps = {
    style: {},
  }

  static getSourcePointId(id) {
    return `source/${id}`
  }

  static getTargetPointId(id) {
    return `target/${id}`
  }

  static getSourcePoint(id) {
    return app.getNode(ConnectorPoint.getSourcePointId(id))
  }

  static getTargetPoint(id) {
    return app.getNode(ConnectorPoint.getTargetPointId(id))
  }

  render() {
    const { id, isTarget, style } = this.props

    return (
      <CachedView
        id={isTarget ? ConnectorPoint.getTargetPointId(id) : ConnectorPoint.getSourcePointId(id)}
        style={{ width: 0, height: 0, ...style }}
      />
    )
  }
}
